import {
    GET_LABEL_PREVIEW, GET_LABEL_PREVIEW_SUCCESS, GET_LABEL_PREVIEW_FAILURE,
    GET_TEMPLATES, GET_TEMPLATES_SUCCESS, GET_TEMPLATES_FAILURE,
    CLEAR_LABEL_PREVIEW,
    GET_LITER_TAX_UUID,
    GET_LITER_TAX_UUID_SUCCESS,
    GET_LITER_TAX_UUID_FAILURE,
    SET_PRINTER_PROFILES,
    UPSERT_PRINTER_PROFILE,
    DELETE_PRINTER_PROFILE,
    SET_MODULE_PRINTER_PROFILE,
    SET_MODULE_TEMPLATE,
    SET_LABELER_MODULE_SETTINGS,
} from 'components/src/modules/labeler/data/actions/actionTypes';
import composeRequest, { checkStatus, handleError, parseText, parseJSON } from '../../../shared/api/core';
import { LabelerTemplate } from 'components/src/modules/labeler/models';
import { API_URLS } from '../../api/ApiUrls';
import {
    GET_LABELER_SUMMARY, GET_LABELER_SUMMARY_FAILURE, GET_LABELER_SUMMARY_SUCCESS
} from './actionTypes';
import { Location } from '../../../shared/models';
import { PaginatedResponse } from '../../../shared/models';
import {
    LabelerModuleSettings,
    PrintModuleId,
    PrinterProfile,
} from '../../../../store/reducers/userDataReducer';


export function getTemplatesFromAPI(selectedLocation: Location) {
    return (dispatch: any) => {
        dispatch(getTemplates());
        const URL = API_URLS.labelerTemplatesUrl + '?business_ids=' + selectedLocation.business_id;
        composeRequest(URL, 'GET', null)
            .catch(handleError) // handle network issues
            .then(checkStatus)
            .then(parseJSON)
            .then((data: PaginatedResponse<LabelerTemplate>) => {
                dispatch(getTemplatesSuccess(data));
            })
            .catch((err: any) => {
                dispatch(getTemplatesFailure(err));
            });
    };
}

export function getLiterTaxUUIDFromAPI() {
    return (dispatch: any) => {
        dispatch(getLiterTaxUUID());
        const URL = API_URLS.literTaxUUIDUrl;
        composeRequest(URL, 'GET', null)
            .catch(handleError) // handle network issues
            .then(checkStatus)
            .then(parseJSON)
            .then((data: PaginatedResponse<LabelerTemplate>) => {
                dispatch(getLiterTaxUUIDSuccess(data));
            })
            .catch((err: any) => {
                dispatch(getLiterTaxUUIDFailure(err));
            });
    };
}

export function getZPLLabelPreview(zpl: string) {
    return (dispatch: any) => {
        dispatch(getLabelPreview());
        const URL = API_URLS.labelerZPLPreviewUrl;
        const payload = { data: zpl };
        composeRequest(URL, 'POST', JSON.stringify(payload))
            .catch(handleError) // handle network issues
            .then(checkStatus)
            .then(parseText)
            .then((data: any) => {
                dispatch(getLabelPreviewSuccess(data));
            })
            .catch((err: any) => {
                dispatch(getLabelPreviewFailure(err));
            });

    };
}

export interface LabelerSummaryResponse {
    activeCount: number;
    authorizedCount: number,
    totalCount: number;
}

export function getLabelerDataSummary(businessId: number | string) {
    return (dispatch: any) => {
        dispatch(getLabelerSummary());
        const URL = API_URLS.labelerSummaryDataUrl + '?business_id=' + businessId;
        composeRequest(URL, 'GET', null)
            .catch(handleError) // handle network issues
            .then(checkStatus)
            .then(parseJSON)
            .then((data: LabelerSummaryResponse) => {
                dispatch(getLabelerSummarySuccess(data));
            })
            .catch((err: any) => {
                dispatch(getLabelerSummaryFailure(err));
            });
    };
}

export const setPrinterProfiles = (profiles: PrinterProfile[]) => ({
    type: SET_PRINTER_PROFILES,
    profiles,
});

export const upsertPrinterProfile = (profile: PrinterProfile) => ({
    type: UPSERT_PRINTER_PROFILE,
    profile,
});

export const deletePrinterProfile = (profileId: string) => ({
    type: DELETE_PRINTER_PROFILE,
    profileId,
});

export const setModulePrinterProfile = (
    moduleId: PrintModuleId,
    profileId: string | null,
) => ({
    type: SET_MODULE_PRINTER_PROFILE,
    moduleId,
    profileId,
});

export const setModuleTemplate = (
    moduleId: PrintModuleId,
    templateId: number | null,
) => ({
    type: SET_MODULE_TEMPLATE,
    moduleId,
    templateId,
});

export const setLabelerModuleSettings = (labelerModule: LabelerModuleSettings) => ({
    type: SET_LABELER_MODULE_SETTINGS,
    labelerModule,
});

function getTemplates() {
    return {
        type: GET_TEMPLATES
    };
}

function getTemplatesSuccess(data: PaginatedResponse<LabelerTemplate>) {
    return {
        type: GET_TEMPLATES_SUCCESS,
        data
    };
}

function getTemplatesFailure(err: any) {
    return {
        type: GET_TEMPLATES_FAILURE,
        err
    };
}

function getLiterTaxUUID() {
    return {
        type: GET_LITER_TAX_UUID
    };
}

function getLiterTaxUUIDSuccess(data: PaginatedResponse<LabelerTemplate>) {
    return {
        type: GET_LITER_TAX_UUID_SUCCESS,
        data
    };
}

function getLiterTaxUUIDFailure(err: any) {
    return {
        type: GET_LITER_TAX_UUID_FAILURE,
        err
    };
}

function getLabelPreview() {
    return {
        type: GET_LABEL_PREVIEW
    };
}

function getLabelPreviewSuccess(data: any) {
    return {
        type: GET_LABEL_PREVIEW_SUCCESS,
        data
    };
}

function getLabelPreviewFailure(err: any) {
    return {
        type: GET_LABEL_PREVIEW_FAILURE,
        err
    };
}

export const clearLabelPreview = () => {
    return {
        type: CLEAR_LABEL_PREVIEW,
    };
};


function getLabelerSummary() {
    return {
        type: GET_LABELER_SUMMARY
    };
}

function getLabelerSummarySuccess(data: LabelerSummaryResponse) {
    return {
        type: GET_LABELER_SUMMARY_SUCCESS,
        data
    };
}

function getLabelerSummaryFailure(err: any) {
    return {
        type: GET_LABELER_SUMMARY_FAILURE,
        err
    };
}
